// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_page_wrapper__12-EH","left":"search_page_left__10YCV","right":"search_page_right__2sfp2"};